// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.

import vars from '../../../../vars.js';

import Jakte from '@drawbotics/jakte-core';
import JaktePluginUserAgent from '@drawbotics/jakte-plugin-user-agent';
import JakteNetwork from '@drawbotics/jakte-plugin-network';
import JakteReferrer from '@drawbotics/jakte-plugin-referrer';

function init() {
  Jakte.use([
    JaktePluginUserAgent,
    JakteNetwork,
    JakteReferrer
  ]);
  Jakte.init({
    id: vars.slug,
    source: vars.source,
    plugins: {
      network: {
        url: 'https://jakte.drawbotics.com/api/v1/sessions',
      }
    }
  });
}

export default {
  init,
};


// WEBPACK FOOTER //
// ./src/static/js/modules/jakte.js